import { Injectable } from '@angular/core';
import { GenericService } from '../../generic.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { LandingService } from '../../landing-page/service/landing.service';
import { TroubleShootingStep } from '../interface/troubleshoot-eh500s.interface';
import { CrowdinService } from '../../shared/service/crowdin.service';

@Injectable({
  providedIn: 'root',
})
export class TroubleShootEh500sService {
  stepsList: TroubleShootingStep[] = [];
  issueName: string | undefined = '';
  currentLanguageName: string = defaultLanguage;

  constructor(
    private genericService: GenericService,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.landingService.languageName$.subscribe((langName) => {
      this.currentLanguageName = langName || defaultLanguage;
    });
  }

  getTroubleShootEh500sIssues(): any[] {
    const issues: any[] = [];
    this.stepsList = [];

    for (const option of this.eh500s.options) {
      const label = this.crowdinService.getTranslation(option.labelKey!);

      if (option.steps?.length) {
        issues.push({ key: option.steps[0].key, label });
        this.stepsList.push(...option.steps);
      } else {
        issues.push({ key: option.key, label });
      }
    }

    return issues;
  }

  setIssuename(issuename: string | undefined) {
    this.issueName = issuename;
  }

  getIssuename() {
    return this.issueName;
  }

  getTroubleShootStep(searchKey: string): TroubleShootingStep | null {
    return this.genericService.findObjectByKey(searchKey, this.eh500s.options);
  }

  getStepState() {
    return this.stepsList;
  }

  getStepIndex(key: string) {
    return this.stepsList.findIndex((step) => step.key === key);
  }

  eh500s: TroubleShootingStep = {
    key: 'eh500s',
    options: [
      {
        key: 'eh500s-machineDown',
        labelKey: 'troubleshooting.eh500s.machineDown.label',
        option: 'troubleshooting.eh500s.machineDown',
        steps: [
          {
            key: 'eh500s-machineDownlist-items',
            options: [],
            machineIssueListItems: [
              {
                keyValue: 1,
                titleKey: 'troubleshooting.eh500s.machineDown.title',
                detailKeys: ['troubleshooting.eh500s.machineDown.details'],
                answered: false,
              },
            ],
          },
        ],
      },
      {
        key: 'eh500s-switch',
        labelKey: 'troubleshooting.eh500s.switch.label',
        option: 'troubleshooting.eh500s.switch',
        steps: [
          {
            key: 'eh500s-switchlist-items',
            options: [],
            machineIssueListItems: [
              {
                keyValue: 2,
                titleKey: 'troubleshooting.eh500s.switch.title',
                detailKeys: ['troubleshooting.eh500s.switch.details'],
                answered: false,
              },
            ],
          },
        ],
      },
      {
        key: 'eh500s-machineInterrupt',
        labelKey: 'troubleshooting.eh500s.machineInterrupt.label',
        option: 'troubleshooting.eh500s.machineInterrupt',
        steps: [
          {
            key: 'eh500s-machineInterruptlist-items',
            options: [],
            machineIssueListItems: [
              {
                keyValue: 3,
                titleKey: 'troubleshooting.eh500s.machineInterrupt.title',
                detailKeys: ['troubleshooting.eh500s.machineInterrupt.details'],
                answered: false,
              },
            ],
          },
        ],
      },
      {
        key: 'eh500s-other',
        labelKey: 'troubleshooting.eh500s.other.label',
        option: 'troubleshooting.eh500s.other',
      },
    ],
  };
}
